module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_2"
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": "1"
    },
    on: {
      "select": _vm.fnSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("私有云")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("智能设备")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("智能家居")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("农业灌溉")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_vm._v("工业采集")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "title",
    style: ({
      backgroundImage: 'url(' + _vm.content.pic + ')'
    })
  }, [_c('p', [_vm._v(_vm._s(_vm.content.title_sub))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.content.sub_des))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.fnToRouter(_vm.content.btn.url)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.btn.name))]), _vm._v(" "), _c('p', [_vm._v("应用产品")]), _vm._v(" "), _c('p', _vm._l((_vm.content.product), function(item, i) {
    return _c('span', {
      key: i,
      on: {
        "click": function($event) {
          _vm.fnToRouter(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.content.content), function(item, i) {
    return [_c('h3', [_vm._v(_vm._s(item.h))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.p))])]
  })], 2)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4fce2e6e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/solution/tab_2.vue
// module id = 784
// module chunks = 1